export default "__VITE_ASSET__BsBBhGOq__"